import { SMSSender } from 'modules/graphql/types';
import { createContext, useContext } from 'react';
import { BaseAssetManagerContextState } from 'modules/assetManager/contexts/BaseAssetManagerContext';
import noop from 'utils/noop';
import { ContactCard } from '../types';

export type ContactCardContextState = BaseAssetManagerContextState<ContactCard> & {
  smsSenders: SMSSender[];
};

export const ContactCardContext = createContext<ContactCardContextState>({
  smsSenders: [],
  assets: [],
  assetTypeName: undefined,
  isModalOpen: false,
  isEditing: false,
  changesMade: false,
  selectedAssetId: undefined,
  assetDetails: {},
  assetErrors: {},
  onSearch: noop,
  setIsModalOpen: noop,
  setIsEditing: noop,
  setChangesMade: noop,
  selectAssetInList: noop,
  handleClose: noop,
  createNew: noop,
  save: noop,
  cancel: noop,
  updateAssetDetails: noop,
  updateAssetErrors: noop,
  deleteAsset: noop,
});

export const useContactCardContext = () => useContext(ContactCardContext);
